<template>
    <div>
        <div class="d-flex align-center py-3">
            <div>
                <div class="display-1">Booking Details</div>
            </div>
            <v-spacer/>

        </div>
        <validation-observer
                ref="observer"
        >
        <v-row>
            <v-col cols="6">
                <validation-provider
                        v-slot="{ errors }"
                        name="Booking Title"
                        rules="required"
                >
                    <v-text-field
                            v-model="booking.courseTitle"
                            label="Booking Title *"
                            :error-messages="errors"
                            required
                    />
                </validation-provider>
                <validation-provider
                        v-slot="{ errors }"
                        name="Booking Date"
                        rules="required"
                >
                    <DatePicker
                            v-model="booking.bookingDate"
                            label="Booking Date *"
                            :error-messages="errors"
                            required
                    />

                </validation-provider>
                <validation-provider
                        v-slot="{ errors }"
                        name="Account Manager"
                        rules="required"
                >
                    <AccountManager
                            v-model="booking.accountManager"
                            :error-messages="errors"
                    />
                </validation-provider>

                <v-text-field
                        v-model="booking.customerPoRef"
                        label="PO Reference"
                />
                <validation-provider
                    v-slot="{ errors }"
                    name="Craft"
                    rules="required"
                >
                  <CraftSearch v-model="booking.craftId" :error-messages="errors"/>
                </validation-provider>
                <v-row>
                    <v-col cols="6">
                        <TypeSelector
                                v-model="booking.trainingType"
                                label="Training Type *"
                                type="training"
                        />
                    </v-col>
                    <v-col cols="6">
                        <TypeSelector
                                v-model="booking.bookingType"
                                label="Booking Type *"
                                type="booking"
                        />
                    </v-col>
                </v-row>

                <h3>Pricing</h3>
                <validation-provider
                        v-slot="{ errors }"
                        name="Tax Date"
                        rules=""
                >
                    <DatePicker
                            v-model="booking.taxDate"
                            label="Tax Date"
                            :error-messages="errors"
                            required
                    />
                </validation-provider>
                <BookingPricingForm :model="booking" />

                <h3>Notes</h3>
                <v-textarea
                        v-model="booking.printedNotes"
                        label="Printed Notes"
                ></v-textarea>

                <v-textarea
                        v-model="booking.nonPrintedNotes"
                        label="Non-Printed Notes"
                ></v-textarea>

            </v-col>
            <v-col cols="6">


            </v-col>
        </v-row>
        </validation-observer>



    </div>
</template>

<script>

    import AccountManager from "../../AutoCompletes/AccountManager";
    import BookingPricingForm from "../BookingPricingForm";
    import DatePicker from "../../DatePicker";
    import TypeSelector from "../../TypeSelector";
    import CraftSearch from "../../AutoCompletes/CraftSearch";
    import moment from "moment";

    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        components: {
            TypeSelector,
            DatePicker,
            AccountManager,
            BookingPricingForm,
            ValidationProvider,
            ValidationObserver,
            CraftSearch
        },
        props: {
            booking: {
                type: Object
            }
        },
        data() {
            return {
                pickerOpen: false,
                taxDatePicker: false,
                bookingTypes: [
                    {code: 'A1', label: 'Training'},
                    {code: 'A2', label: 'Consultancy'},
                    {code: 'A3', label: 'Other'},
                ],
                trainingTypes: [
                    {code: 'B2', label: 'Single Company'},
                    {code: 'B3', label: 'Public'},
                ],
            }
        },
        computed: {
            formattedBookingDate() {
                return moment(this.booking.bookingDate).format("ddd, D MMMM YYYY");
            },
        },
        methods: {
            validate () {
                return this.$refs.observer.validate()
            },
        },

    }
</script>